import type { TurbosPoolRewardItem } from '@models/pool.model';
import { Decimal, BN } from 'turbos-clmm-sdk';

const oneWeek = new Decimal(604800);

export const getRewardWeekAmount = (reward: TurbosPoolRewardItem) => {
  return oneWeek.mul(new BN(reward.fields.emissions_per_second).shrn(64).toString());
};
